import { render, staticRenderFns } from "./WorkerCards.vue?vue&type=template&id=4fd1ec2a"
import script from "./WorkerCards.vue?vue&type=script&lang=js"
export * from "./WorkerCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports